// AddOrderPage.js
import React from 'react';
import OrderForm from './OrderForm'; // adjust path
import { useNavigate } from 'react-router-dom';

const AddOrderPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: '20px' }}>
      {/* <h2>Add New Store Order</h2> */}
      <OrderForm />
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          ← Back
        </button>
      </div>
    </div>
  );
};

export default AddOrderPage;
